import { FolderFormDataCreateInput, FolderFormDataObjectDepre, FolderFormDataUpdateInput } from '@it2go/types';
import { Component, EventEmitter, inject, Output, signal, ChangeDetectionStrategy } from '@angular/core';
import { FormSetEnum } from '../../../../../../../../../types/src/services/enum/form-set.enum';
import { FolderFormsRecordModalStore } from './folder-forms-record-modal.store';
import { FolderFormDataObject } from '@libs/types/src/services/object-type/form/folder-form-data.object';
import { Dialog } from '@openng/optimus-ui/dialog';
import { TranslatePipe } from '@ngx-translate/core';
import { FormEsasFormComponent } from '../form-esas-form/form-esas-form.component';
import { FormMsseFormComponent } from '../form-msse-form/form-msse-form.component';
import { FormIadlFormComponent } from '../form-iadl-form/form-iadl-form.component';
import { FormDeknFormComponent } from '../form-dekn-form/form-dekn-form.component';
import { FormPpsFormComponent } from '../form-pps-form/form-pps-form.component';
import { FormOpzFormComponent } from '../form-opz-form/form-opz-form.component';
import { FormBiFormComponent } from '../form-bi-form/form-bi-form.component';
import { FormNiFormComponent } from '../form-ni-form/form-ni-form.component';
import { FormRvdFormComponent } from '../form-rvd-form/form-rvd-form.component';

@Component({
    selector: 'app-folder-forms-record-modal',
    templateUrl: 'folder-forms-record-modal.component.html',
    styleUrl: 'folder-forms-record-modal.component.scss',
    providers: [FolderFormsRecordModalStore],
    changeDetection: ChangeDetectionStrategy.Eager,
    imports: [
        Dialog,
        TranslatePipe,
        FormEsasFormComponent,
        FormMsseFormComponent,
        FormIadlFormComponent,
        FormDeknFormComponent,
        FormPpsFormComponent,
        FormOpzFormComponent,
        FormBiFormComponent,
        FormNiFormComponent,
        FormRvdFormComponent,
    ],
})
export class FolderFormsRecordModalComponent {

    public readonly store = inject(FolderFormsRecordModalStore);

    @Output() onCreated = new EventEmitter<FolderFormDataObject>();

    protected readonly recordFormModalVisible = signal(false);
    protected readonly recordFormSetId = signal<number | null>(null);
    protected readonly recordFormSetType = signal<FormSetEnum | null>(null);
    protected readonly recordFormData = signal<FolderFormDataObjectDepre | null>(null);
    protected readonly recordFormDataCopy = signal(false);

    public openRecordForm(id: number, setType: FormSetEnum, record: FolderFormDataObjectDepre | null = null, copy = false) {
        this.recordFormSetType.set(setType);
        this.recordFormSetId.set(id);
        this.recordFormModalVisible.set(true);
        this.recordFormData.set(record);
        this.recordFormDataCopy.set(copy);
    }

    public closeRecordForm() {
        this.recordFormSetType.set(null);
        this.recordFormSetId.set(null);
        this.recordFormModalVisible.set(false);
        this.recordFormData.set(null);
        this.recordFormDataCopy.set(false);
    }

    protected async submitFormData(input: FolderFormDataCreateInput | FolderFormDataUpdateInput): Promise<void> {
        if ((input as any).id) {
            this.store.api.updateFolderFormData(input as FolderFormDataUpdateInput);
        } else {
            const res = await this.store.folderGql.createFolderFormData(input as FolderFormDataCreateInput).promise();
            this.onCreated.emit(res);
        }

        this.closeRecordForm();
    }

    protected readonly FormSetEnum = FormSetEnum;

}
